import { render, staticRenderFns } from "./UncheckedSpecialOfferReceipt.vue?vue&type=template&id=155ad1da&scoped=true&"
import script from "./UncheckedSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
export * from "./UncheckedSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./UncheckedSpecialOfferReceipt.vue?vue&type=style&index=0&id=155ad1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ad1da",
  null
  
)

export default component.exports